/*
 * @Author: Branton
 * @Date: 2025-10-28 17:01:49
 * @LastEditTime: 2025-11-21 15:48:59
 * @LastEditors: Branton
 * @Description:
 * @FilePath: \Rms-Tender-Frontend\src\components\select\ViewMoreSelect.tsx
 * 暂无
 */
import { Select, Spin } from 'antd';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import ZeissSelect from '.';
interface UserListInterface {
  userId: string;
  realName: string;
}

const curPageSize = 10000;
const ViewMoreSelect = forwardRef((props: any, ref) => {
  const {
    getDefaultListData,
    getListData,
    showSearch = false,
    onSearch,
    optionFormat,
    needInit = false,
    needDefault = false,
    ...other
  } = props;
  const [loading, setLoading] = useState(false);
  const [listData, setListData] = useState<any>([]);
  const [searchData, setSearchData] = useState<any>({});
  const [pagination, setPagination] = useState({
    total: 0,
    pageNumber: 1,
    pageSize: curPageSize
  });

  useImperativeHandle(ref, () => ({
    // 提供一个外部调用重新请求的方法
    rQuery: (formData: any) => {
      return handleInit(formData, true, true, formData.needDefault);
    },
    // 调用重置
    reset: () => {
      setListData([]);
      setSearchData({});
      setPagination({
        total: 0,
        pageNumber: 0,
        pageSize: curPageSize
      });
    }
  }));

  /**
   * 获取初始化数据
   */
  const handleInit = async (
    newSearchData?: any,
    isQueryData = false, // 搜索
    isExternalCall = false, // 外部调用
    forceNeedDefault?: boolean
  ) => {
    let curNeedDefault =
      forceNeedDefault ??
      (!isQueryData
        ? isExternalCall
          ? newSearchData.needDefault
          : needDefault
        : false);
    const obj = {
      ...newSearchData,
      pageNumber: 1,
      pageSize: curPageSize,
      needDefault: curNeedDefault
    };
    try {
      const res = await getListData(obj);
      if (res?.data) {
        setListData(res?.data || []);
        setPagination({
          pageSize: curPageSize,
          pageNumber: 1,
          total: Number(res?.total)
        });
        return res?.data;
      }
    } catch (err) {
      console.log(err);
    }
  };

  /**
   * 动态请求数据
   */
  const fetchMoreData = async (
    newPagination: any,
    newListData: any,
    newSearchData?: any
  ) => {
    if (loading) return;
    setLoading(true);
    const obj = {
      ...newSearchData,
      pageNumber: newPagination.pageNumber + 1,
      pageSize: newPagination.pageSize
    };
    try {
      const res = await getListData(obj);

      if (res.data) {
        setListData([...newListData, ...(res.data || [])]);
        setPagination({
          pageSize: newPagination.pageSize,
          pageNumber: Number(res.pageNumber),
          total: Number(res.total)
        });
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
    }
  };

  /**
   * 下拉框滚动
   * @param e dom元素
   */
  const handleScroll = (e: any) => {
    const { target } = e;
    if (target.scrollTop + target.clientHeight + 1 >= target.scrollHeight) {
      if (pagination.total <= listData.length && listData.length > 0) return;
      fetchMoreData(pagination, listData, searchData);
    }
  };

  /**
   * 触发搜索
   * @param value
   */
  const handleOnSearch = async (value: string) => {
    if (typeof onSearch === 'function') {
      const result = onSearch(value);
      setSearchData(result);
      handleInit(result, true);
    }
  };

  useEffect(() => {
    needInit && handleInit(searchData);
  }, []);

  return (
    <ZeissSelect
      allowClear
      onPopupScroll={handleScroll}
      // loading={loading}
      {...(showSearch && {
        showSearch,
        onSearch: handleOnSearch,
        filterOption: false
      })}
      options={listData.map((x: UserListInterface | any) => ({
        label: x[optionFormat.label],
        value: optionFormat.specialVal
          ? `${x[optionFormat.value]}-${x[optionFormat.specialVal]}`
          : `${x[optionFormat.value]}`
      }))}
      {...other}
    >
      {/* 添加下拉时的loading */}
      {loading && (
        <Select.Option
          disabled
          style={{ textAlign: 'center' }}
          value={'loading'}
        >
          <Spin spinning={loading} />
        </Select.Option>
      )}
    </ZeissSelect>
  );
});
export default ViewMoreSelect;
